import type {
  ConfiguratorFieldState,
  ConfiguratorFunctionValidation,
} from '@ui/features/configurator/types';

import { maxLength } from './max-length';
import { validateNumericality } from './numericality';
import { validResult } from './result';
import type { FunctionValidatorsMap, ValidationResult } from './types';

const functionValidators: FunctionValidatorsMap = {
  numericality: validateNumericality,
  maxLength: maxLength,
};

export function validateFunction(
  fields: ConfiguratorFieldState,
  fieldKey: string,
  validation: ConfiguratorFunctionValidation,
): ValidationResult {
  const fn = functionValidators[validation.name];

  if (!fn) {
    // Ignore missing functions and return a valid result
    console.error(
      `Unable to find validator function named: ${validation.name}`,
    );

    return validResult;
  }

  return fn(fields, fieldKey, validation);
}
